<template>
  <div>
    <div id="machinetest">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
        <el-breadcrumb-item>真机测试</el-breadcrumb-item>
      </el-breadcrumb>

     <div>
       <p class="title">真机测试</p>
       <div class="machine-text">
         <p>
           下载DemoApp，在目标设备上安装对应App，登录开发者账号后，即可进行技能测试
         </p>

         <el-button type="primary" size="mini" @click="AppDownload">下载App</el-button>
       </div>
     </div>
    </div>

  </div>
</template>
<script>
  import {settingSerApi, skillDetailApi, saveAuthorizationApi, searchAccountInfoApi} from '@/api'
  import qs from 'qs'
  export default {
    data() {
      return {
        show3: false,

      }
    },
    created () {
    },
    computed: {

    },
    mounted () {

    },
    methods: {
        AppDownload () {
            if (window.location.host.includes('opentw.ainirobot.com')) {
                window.location.href = 'http://jp-dlbcdn.update.ainirobot.com/open/sdk/DemoTest_taiwan.apk'
            } else {
                window.location.href = 'http://dlbcdn.update.ainirobot.com/open/sdk/DemoTest.apk'
            }
        }
    }
  }
</script>
<style  rel="stylesheet/scss" lang="scss">
  #machinetest{
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .machine-text{
      padding:20px 0 0 20px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/setting/MachineTest.vue